import MyBookmarks from './MyBookmarks';

export default MyBookmarks;
